import { render, staticRenderFns } from "./OrderShow.vue?vue&type=template&id=55c9beae&"
import script from "./OrderShow.vue?vue&type=script&lang=js&"
export * from "./OrderShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports